
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import Form19StyleOfProceeding from "@/components/process/Form19/components/Form19StyleOfProceeding.vue";
import { form19StatusInfoType } from '@/types/Information/Form19';

import "@/store/modules/forms/form20";
const form20State = namespace("Form20");

@Component({
    components:{
        Form19ProcessHeader,        
        Form19StyleOfProceeding
    }
})
export default class FillForm19 extends Vue {

    @form20State.Action
    public UpdateCurrentNoticeOfObjectionToWithdrawalId!: (newCurrentNoticeOfObjectionToWithdrawalId: string) => void


    stepsCompleted = {} as form19StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }

    public startNewForm20Document(){
        this.UpdateCurrentNoticeOfObjectionToWithdrawalId(null)
        this.$router.push({name: "start-form20" });
    }
}
